import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../setup'
import {useEffect} from 'react'
import {CreateDynamicClass} from '../functions/Static'

export const useWorkspaceStyles = () => {
    const {primary, secondary} = useSelector(
        (state: RootState) => ({
            primary: state.workspace.colors.primary,
            secondary: state.workspace.colors.secondary,
        }),
        shallowEqual,
    )

    useEffect(() => {
        const root = document.documentElement
        root.style.setProperty('--primaryWorkspaceColor50', `${primary}50`)
        root.style.setProperty('--secondaryWorkspaceColor50', `${secondary}50`)
        root.style.setProperty('--primaryWorkspaceColor', primary)
        root.style.setProperty('--secondaryWorkspaceColor', secondary)
        CreateDynamicClass(primary, secondary)
    }, [primary, secondary])
}